import {
  getNewsList
} from '@/api/news/selectNews' //引入新闻列表 api 接口

import {
  getNewsListByPage
} from '@/api/news/selectNews' //引入新闻列表分页 api 接口

import {
  getNewsContent
} from '@/api/news/selectNews' //引入新闻内容 api 接口

import {
  updateHot
} from '@/api/news/updateNews' //引入修改新闻热度 api 接口


import {
  getAllNewsList
} from '@/api/news/selectNews' //引入新闻列表 api 接口

import {
  updateNewsContent
} from '@/api/news/updateNews' //引入修改新闻内容 api 接口

import {
  updateNewsInfo
} from '@/api/news/updateNews' //引入修改新闻信息 api 接口

import {
  updateNewsReleaseKbn
} from '@/api/news/updateNews' //引入修改新闻发布状态信息 api 接口

import {
  addNews
} from '@/api/news/addNews' //引入添加新闻 api 接口

import {
  deleteNews
} from '@/api/news/deleteNews' //引入添加新闻 api 接口



//浏览次数
import {
  addViewed
} from '@/api/viewed/addViewed' //引入添加浏览次数 api 接口
import {
  getViewList
} from '@/api/viewed/select' //引入添加浏览次数 api 接口
import {
  getViewedData
} from '@/api/viewed/select' //引入添加浏览次数 api 接口

const apiInterface = {
  actions: {
    // 获取新闻列表
    GetNewsList({
      commit
    }, pagination) { //定义 GetNewsList 方法，在组件中使用 this.$store.dispatch("GetNewsList") 调用
      return new Promise((resolve, reject) => { //封装一个 Promise
        getNewsList(pagination.page, pagination.pageNum, pagination.searchWord).then(response => {
          commit('') //提交一个 mutation，通知状态改变
          resolve(response) //将结果封装进 Promise
        }).catch(error => {
          reject(error)
        })
      })
    },

    GetNewsListByPage({
      commit
    }, pagination) { //定义 GetNewsList 方法，在组件中使用 this.$store.dispatch("GetNewsListByPage") 调用
      return new Promise((resolve, reject) => { //封装一个 Promise
        getNewsListByPage(pagination.page, pagination.pageNum, pagination.searchWord).then(response => {
          commit('') //提交一个 mutation，通知状态改变
          resolve(response) //将结果封装进 Promise
        }).catch(error => {
          reject(error)
        })
      })
    },
    
    UpdateHot({
      commit
    }, news) { //定义 updateHot 方法，在组件中使用 this.$store.dispatch("updateHot") 调用
      return new Promise((resolve, reject) => { //封装一个 Promise
        updateHot(news.newsId,news.hot).then(response => {
          commit('') //提交一个 mutation，通知状态改变
          resolve(response) //将结果封装进 Promise
        }).catch(error => {
          reject(error)
        })
      })
    },

    GetNewsContent({
      commit
    }, newsId) { //定义 GetNewsContent 方法，在组件中使用 this.$store.dispatch("GetNewsContent") 调用
      return new Promise((resolve, reject) => { //封装一个 Promise
        getNewsContent(newsId).then(response => {
          commit('') //提交一个 mutation，通知状态改变
          resolve(response) //将结果封装进 Promise
        }).catch(error => {
          reject(error)
        })
      })
    },

    GetAllNewsList({
      commit
    }) {
      return new Promise((resolve, reject) => { //封装一个 Promise
        getAllNewsList().then(response => {
          commit('') //提交一个 mutation，通知状态改变
          resolve(response) //将结果封装进 Promise
        }).catch(error => {
          reject(error)
        })
      })
    },

    UpdateNewsContent({
      commit
    }, news) {
      return new Promise((resolve, reject) => { //封装一个 Promise
        updateNewsContent(news.newsId, news.newsTitle, news.newsIntroduction,news.photo,news.createTime,news.updateTime,news.newsContent).then(response => {
          commit('') //提交一个 mutation，通知状态改变
          resolve(response) //将结果封装进 Promise
        }).catch(error => {
          reject(error)
        })
      })
    },

    UpdateNewsInfo({
      commit
    }, news) {
      return new Promise((resolve, reject) => { //封装一个 Promise
        updateNewsInfo(news.newsId, news.newsTitle,news.newsIntroduction,news.photo,news.updateTime).then(response => {
          commit('') //提交一个 mutation，通知状态改变
          resolve(response) //将结果封装进 Promise
        }).catch(error => {
          reject(error)
        })
      })
    },

    UpdateNewsReleaseKbn({
      commit
    }, news) {
      return new Promise((resolve, reject) => { //封装一个 Promise
        updateNewsReleaseKbn(news.newsId, news.releaseKbn,news.updateTime).then(response => {
          commit('') //提交一个 mutation，通知状态改变
          resolve(response) //将结果封装进 Promise
        }).catch(error => {
          reject(error)
        })
      })
    },

    AddNews({
      commit
    }, news) {
      return new Promise((resolve, reject) => { //封装一个 Promise
        addNews(news.newsTitle, news.newsIntroduction, news.photo, news.newsAuthor,news.createTime,news.updateTime,news.newsContent).then(response => {
          commit('') //提交一个 mutation，通知状态改变
          resolve(response) //将结果封装进 Promise
        }).catch(error => {
          reject(error)
        })
      })
    },

    DeleteNews({
      commit
    }, newsIds) {
      return new Promise((resolve, reject) => { //封装一个 Promise
        deleteNews(newsIds).then(response => {
          commit('') //提交一个 mutation，通知状态改变
          resolve(response) //将结果封装进 Promise
        }).catch(error => {
          reject(error)
        })
      })
    },

//浏览次数



    AddViewed({
      commit
    },) {
      return new Promise((resolve, reject) => { //封装一个 Promise
        addViewed().then(response => {
          commit('') //提交一个 mutation，通知状态改变
          resolve(response) //将结果封装进 Promise
        }).catch(error => {
          reject(error)
        })
      })
    },
    
    GetViewedList({
      commit
    }, date) {
      return new Promise((resolve, reject) => { //封装一个 Promise
        getViewList(date.startTime,date.endTime).then(response => {
          commit('') //提交一个 mutation，通知状态改变
          resolve(response) //将结果封装进 Promise
        }).catch(error => {
          reject(error)
        })
      })
    },

    GetViewedData({
      commit
    },year) {
      return new Promise((resolve, reject) => { //封装一个 Promise
        getViewedData(year).then(response => {
          commit('') //提交一个 mutation，通知状态改变
          resolve(response) //将结果封装进 Promise
        }).catch(error => {
          reject(error)
        })
      })
    },


  }
}
export default apiInterface